import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { incrementQuantity, decrementQuantity, removeItem, clearCart } from '../redux/slices/cartSlice';
import { MDBIcon } from 'mdbreact';
import '../../style/cart.css';

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);

  const getTotal = () => {
    let totalQuantity = 0;
    let totalPrice = 0;
    cart.forEach((item) => {
      totalQuantity += item.quantity;
      totalPrice += item.price * item.quantity;
    });
    return { totalPrice, totalQuantity };
  };

  const handleContinueCheckout = () => {
    navigate('/checkout');
  };

  if (cart.length === 0) {
    return (
      <div className="text-center mt-5">
        <h3 className="fs-bold">
          Your Shopping <MDBIcon icon="shopping-bag" /> is Empty
        </h3>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <h1 className="cart-heading text-center display-3" style={{ fontFamily: 'fantasy', color: '#C51605' }}>
        Cart
      </h1>

      <div className="cartWrapper">
        {cart.map((product) => (
          <div key={product.id} className="cartCard">
            <img src={product.image} alt="" className="productImage" />
            <div className="productDetails">
              <h5 className="productTitle">{product.title.slice(0, 20)}</h5>
              <h5 className="productPrice">${product.price}</h5>
            </div>
            <div className="cartItem__incrDec">
              <button className="quantityButton" onClick={() => dispatch(decrementQuantity(product.id))}>
                -
              </button>
              <p className="quantityText">{product.quantity}</p>
              <button className="quantityButton" onClick={() => dispatch(incrementQuantity(product.id))}>
                +
              </button>
            </div>
            <button className="removeButton" onClick={() => dispatch(removeItem(product.id))} style={{ color: '#E5B836', fontWeight: 'bold' }}>
              Remove
            </button>
          </div>
        ))}
      </div>

      <div className="cartFooter">
        <div className="d-flex align-items-center justify-content-center">
          <button className="continueButton btn text-white font-bold" onClick={handleContinueCheckout} style={{ backgroundColor: '#C51605' }}>
            Continue Checkout
          </button>

          <button className="clearButton btn border ml-2" onClick={() => dispatch(clearCart())}>
            Clear Cart
          </button>
        </div>
        <div className="text-center mt-3">
          <p className="cartFooter__total">
            Total ({getTotal().totalQuantity} items): <strong>${getTotal().totalPrice.toFixed(2)}</strong>
          </p>
        </div>
      </div>

      {/* Additional media query for mobile screens */}
      <style>
        {`
          @media (max-width: 767px) {
            .cartWrapper {
              display: flex;
              flex-direction: column;
            }

            .cartCard {
              margin-bottom: 20px;
            }

            .productDetails {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 10px;
            }

            .productPrice {
              margin-top: 5px;
            }

            .cartItem__incrDec {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            }

            .quantityButton {
              font-size: 18px;
              padding: 5px 10px;
            }

            .quantityText {
              font-size: 18px;
              margin: 0 6px;
            }

            .removeButton {
              width: 100%;
            }
            .productTitle,.productPrice {
              font-size: 12px;
              margin-left:12px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Cart;
